// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"67585c3b39b2a6f4","5285":"b75a49945c69eabe"}[chunkId] + ".css";
};